var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conecta-ndv-base" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 m12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    sm12: "",
                    md12: "",
                    layout: "",
                    wrap: "",
                    "mt-4": "",
                    "mb-2": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm9: "",
                        md9: "",
                        layout: "",
                        wrap: ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "", layout: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: { label: "Fecha Inicio", max: _vm.now },
                                model: {
                                  value: _vm.objectParam.start_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "start_date", $$v)
                                  },
                                  expression: "objectParam.start_date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: { label: "Fecha Fin", max: _vm.now },
                                model: {
                                  value: _vm.objectParam.end_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "end_date", $$v)
                                  },
                                  expression: "objectParam.end_date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nombre Nota de Venta",
                                  items: _vm.filter.names,
                                  "item-text": "ndvnombre",
                                  "item-value": "ndvnombre",
                                  clearable: "",
                                  "prepend-icon": "home_repair_service"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.ndvnombre,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "ndvnombre", $$v)
                                  },
                                  expression: "objectParam.ndvnombre"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "", layout: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Tipo de Venta",
                                  items: _vm.filter.type_of_sales,
                                  "item-text": "ndvtipo_venta",
                                  "item-value": "ndvtipo_venta",
                                  clearable: "",
                                  "prepend-icon": "real_estate_agent"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.ndvtipo_venta,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objectParam,
                                      "ndvtipo_venta",
                                      $$v
                                    )
                                  },
                                  expression: "objectParam.ndvtipo_venta"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", m4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Cliente",
                                  items: _vm.filter.custumers,
                                  "item-text": "ndvcliente_razon",
                                  "item-value": "ndvcliente_rut",
                                  clearable: "",
                                  "prepend-icon": "person"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.ndvcliente_rut,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objectParam,
                                      "ndvcliente_rut",
                                      $$v
                                    )
                                  },
                                  expression: "objectParam.ndvcliente_rut"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Estado en Conecta",
                                  items: _vm.filter.status,
                                  "item-text": "configvalor",
                                  "item-value": "configid",
                                  clearable: "",
                                  "prepend-icon": "home_repair_service"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.ndvestado_conecta,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objectParam,
                                      "ndvestado_conecta",
                                      $$v
                                    )
                                  },
                                  expression: "objectParam.ndvestado_conecta"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Por Reservar",
                                  items: _vm.filter.por_reservar,
                                  "item-text": "configvalor",
                                  "item-value": "configid",
                                  clearable: "",
                                  "prepend-icon": "home_repair_service"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.ndvpor_reservar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objectParam,
                                      "ndvpor_reservar",
                                      $$v
                                    )
                                  },
                                  expression: "objectParam.ndvpor_reservar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm3: "",
                        md3: "",
                        layout: "",
                        "mt-2": ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleSearchFilter } },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleClearFilter } },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("clear")
                          ]),
                          _vm._v("Limpiar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                md12: "",
                layout: "",
                "justify-end": "",
                "align-center": "",
                "mt-3": "",
                "mb-4": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: { click: _vm.getCSV }
                },
                [
                  _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                    _vm._v("cloud_download")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", { staticClass: "importExportBtnTexto" }, [
                    _vm._v("Exportar"),
                    _c("br"),
                    _vm._v("CSV")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "" } },
            [
              _c("GridComponent", {
                staticClass: "ag-theme-material",
                attrs: { "grid-options": _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogPopUp,
          titulo: _vm.contextPopUp.title,
          mensaje: _vm.contextPopUp.msg,
          textoBtnSi: _vm.$t(_vm.contextPopUp.btnConfirmation),
          textoBtnNo: _vm.$t("Cancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleShowPopUp($event)
          }
        }
      }),
      _vm.showModalViewDetail
        ? _c("NDVModalTabs", {
            attrs: { data: _vm.data },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showModalEnvio
        ? _c("NVDModalEnvioReservations", {
            attrs: { data: _vm.data, tipo_emision: _vm.tipo_emision },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }